import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken } from '@vibesites/runtime/react';
import { EditableToken } from '@vibesites/runtime/react';
import { RichTextContent } from '@vibesites/runtime/react';

export function Fees() {
  const title = useContentToken('fees.title');

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <EditableToken path="fees.title" defaultValue="Fees & Policies" as="h2" className="font-heading text-3xl sm:text-4xl font-normal text-[var(--vibe-color-text)] mb-4 uppercase tracking-wide">
            {title}
          </EditableToken>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="p-6 bg-[var(--vibe-color-surface)] border border-[var(--vibe-color-border)]">
            <h3 className="font-heading text-lg font-normal text-[var(--vibe-color-primary)] mb-4 uppercase tracking-wider">
              Pet Policy
            </h3>
            <RichTextContent
              path="fees.pet_policy"
              label="Pet Policy"
              defaultValue="<p>Dogs and Cats Allowed</p><p>Weight limits and breed restrictions apply. Call for full pet policy.</p>"
              as="div"
              className="font-body text-sm text-[var(--vibe-color-text)] space-y-2 [&_p]:mb-2 [&_a]:text-primary [&_a]:underline"
            />
          </div>

          <div className="p-6 bg-[var(--vibe-color-surface)] border border-[var(--vibe-color-border)]">
            <h3 className="font-heading text-lg font-normal text-[var(--vibe-color-primary)] mb-4 uppercase tracking-wider">
              Applicant Fees
            </h3>
            <RichTextContent
              path="fees.applicant_fees"
              label="Applicant Fees"
              defaultValue="<p>Application fee: $50 Per Person</p><p>Admin Fee: $250</p><p>Deposit: $200</p>"
              as="div"
              className="font-body text-sm text-[var(--vibe-color-text)] space-y-2 [&_p]:mb-2 [&_a]:text-primary [&_a]:underline"
            />
          </div>

          <div className="p-6 bg-[var(--vibe-color-surface)] border border-[var(--vibe-color-border)]">
            <h3 className="font-heading text-lg font-normal text-[var(--vibe-color-primary)] mb-4 uppercase tracking-wider">
              Qualifying Criteria
            </h3>
            <RichTextContent
              path="fees.qualifying_criteria"
              label="Qualifying Criteria"
              defaultValue="<p>Income verification is required during the application process.</p><p>Credit and criminal background checks are required.</p>"
              as="div"
              className="font-body text-sm text-[var(--vibe-color-text)] space-y-2 [&_p]:mb-2 [&_a]:text-primary [&_a]:underline"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'Fees',
  displayName: 'Fees & Policies',
  tokens: {
    'fees.title': {
      label: 'Title',
      type: 'text',
      defaultValue: 'Fees & Policies',
    },
    'fees.pet_policy': {
      label: 'Pet Policy',
      type: 'richtext',
      defaultValue: '<p>Dogs and Cats Allowed</p><p>Weight limits and breed restrictions apply. Call for full pet policy.</p>',
    },
    'fees.applicant_fees': {
      label: 'Applicant Fees',
      type: 'richtext',
      defaultValue: '<p>Application fee: $50 Per Person</p><p>Admin Fee: $250</p><p>Deposit: $200</p>',
    },
    'fees.qualifying_criteria': {
      label: 'Qualifying Criteria',
      type: 'richtext',
      defaultValue: '<p>Income verification is required during the application process.</p><p>Credit and criminal background checks are required.</p>',
    },
  },
};

(Fees as any).contentSchema = contentSchema;

export default Fees;
